import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import EmployeeData from '../../../components/Employee/Dashboard/EmployeeData';
import AttendanceData from '../../../components/Employee/Dashboard/AttendanceData';
import MyRequests from '../../../components/Employee/Dashboard/MyRequests';
import Benefits from '../../../components/Employee/Dashboard/Benefits';
import BirthCalendar from '../../../components/Employee/Dashboard/BirthCalendar';
import PendingDocuments from '../../../components/Employee/Dashboard/PendingDocuments';
import MyDocuments from '../../../components/Employee/Dashboard/MyDocuments';
import InternalVacanciesCard from '../../../components/Employee/Dashboard/InternalVacanciesCard';
import TrainingCard from '../../../components/Employee/Dashboard/TrainingCard';

const basicAttendance = (employeeId, companyId) => [
  {
    date: new Date(),
    time: new Date().toLocaleTimeString(),
    branchOfficeId: '',
    timeType: '',
    parsedTime: '',
    coordenates: {
      lat: -33.0011,
      lng: -70.11
    },
    employeeId,
    companyId
  }
];

const basicActivityAttendance = (employeeId, companyId) => [
  {
    date: new Date(),
    time: new Date().toLocaleTimeString(),
    timeType: '',
    parsedTime: '',
    latitude: -33.0011,
    longitude: -70.11,
    employeeId,
    companyId,
    activity: '',
    marking_type: 'profile_web',
    device_type: 'web'
  }
];

const MyProfileDashboardIndex = ({ currentTab, user }) => {
  const { currentEmployee, currentCompany } = useSelector(state => state.auth);
  const [attendances, setAttendances] = useState(basicAttendance(currentEmployee, currentCompany.id));
  const [activityAttendances, setActivityAttendances] = useState(basicAttendance(currentEmployee, currentCompany.id));
  const [totalItemsRequest, setTotalItemsRequest] = useState(6);
  const { companyModules } = currentCompany;
  const peopleManagement = companyModules?.includes('people_management');
  const signature = companyModules?.includes('signature');

  useEffect(() => {
    let isMounted = true; // Flag to track if component is mounted

    if (isMounted) {
      setAttendances(basicAttendance(currentEmployee, currentCompany.id));
      setActivityAttendances(basicActivityAttendance(currentEmployee, currentCompany.id));
    }

    return () => {
      isMounted = false; // Cleanup function to set the flag to false when the component unmounts
    };
  }, [currentEmployee, currentCompany.id]);

  return (
    <>
      <Row className="g-3 g-md-4">
        <Col xs={12} sm={6} md={6} xl={6} className="mb-1 mt-2 position-relative">
          <EmployeeData user={user} />
        </Col>
        <Col xs={12} sm={3} md={3} xl={3} className="mb-1 mt-2 position-relative">
          {signature && (
            <PendingDocuments
              topClass="top-header-light-gray"
              tab="profile"
              currentEmployee={currentEmployee}
              totalItemsRequest={totalItemsRequest}
              currentTab={currentTab}
            />
          )}
        </Col>
        <Col xs={12} sm={3} md={3} xl={3} className="mb-1 mt-2 position-relative">
          <AttendanceData
            attendances={attendances}
            activityAttendances={activityAttendances}
            currentEmployee={currentEmployee}
          />
        </Col>
      </Row>
      <Row className="g-3 g-md-4 d-flex align-items-stretch">
        <Col xs={12} sm={6} md={6} xl={6} className="mb-1">
          <Row className="mb-1 mt-1">
            <Col xs={12} sm={12} md={12} xl={12}>
              <MyRequests
                currentEmployee={currentEmployee}
                widthSm={4}
                topClass="top-header-green"
                setTotalItemsRequest={setTotalItemsRequest}
              />
            </Col>
          </Row>
          <Row className="mb-1 mt-2 position-relative">
            <Col xs={12} sm={6} md={6} xl={6}>
              {peopleManagement && <MyDocuments />}
            </Col>
            <Col xs={12} sm={6} md={6} xl={6}>
              <BirthCalendar />
            </Col>
          </Row>
          <Row className="mb-1 mt-2 position-relative">
            <Col xs={12} sm={6} md={6} xl={6}>
              <InternalVacanciesCard />
            </Col>
            <Col xs={12} sm={6} md={6} xl={6}>
              <TrainingCard />
            </Col>
          </Row>
        </Col>

        <Col xs={12} sm={6} md={6} xl={6} className="mb-1">
          <Benefits />
        </Col>
      </Row>
    </>
  );
};

export default MyProfileDashboardIndex;
